import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme: { colors } }) => css`
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    width: 585px;
    max-width: 100%;
    gap: 32px;

    > header {
      display: grid;
      grid-template-columns: 32px auto;
      align-items: center;
      gap: 8px;

      svg {
        color: ${colors.green2};
        justify-self: center;
        cursor: pointer;
      }
    }

    > footer {
      display: flex;
      justify-content: center;
    }
  `}
`;

export const Form = styled.form`
  margin: 32px 0 0;
  display: flex;
  justify-content: center;

  > div {
    max-width: 328px;
    display: flex;
    flex-direction: column;
    align-self: center;
    gap: 8px;
  }

  section {
    display: grid;
    gap: 8px;
    grid-template-columns: 146px auto;
  }
`;
